import { FC, useEffect, useState } from "react";

import Prism from "prismjs";
import "prismjs/components/prism-json"; // Language
import "prismjs/themes/prism.css"; // Theme

import { parsingLAStore } from "../utils/mobx/ParsingLAStore";
import { resultInteractionStore } from "../utils/mobx/ResultInteractionStore";
import { cn } from "../utils/style";

interface ParsingResultLAHtmlViewProps {
  disabled?: boolean;
}

const ParsingResultLAHtmlView: FC<ParsingResultLAHtmlViewProps> = ({
  disabled = false,
}) => {
  const {
    setAdditionalFocusIndexes,
    additionalFocusIndexes,
    hoveredBoxIds,
    setHoveredBoxIds,
    selectedBoxIds,
    setSelectedBoxIds,
    focusIndex: curIndex,
    setFocusIndex: setIndex,
    setFocusEnable,
  } = resultInteractionStore;
  const { laElements, values, orgLargestId } = parsingLAStore;
  const [isRowClicked, setIsRowClicked] = useState(false);

  const [hoverIndex, setHoverIndex] = useState<number>(-1);
  // const [hoverTableIndex, setHoverTableIndex] = useState<number>(-1);

  // html 파싱하기

  useEffect(() => {
    Prism.highlightAll();
  }, [values]);

  useEffect(() => {
    // 이미지뷰에서 박스가 클릭되었을때만 자동 스크롤
    if (isRowClicked) {
      setIsRowClicked(false);
      return;
    }
    if (selectedBoxIds.length) {
      const boxId = selectedBoxIds[0];
      document.getElementById(`row-${boxId}`)?.scrollIntoView({
        behavior: "smooth" as ScrollBehavior,
        block: "center" as ScrollLogicalPosition,
      });
      laElements.forEach((laElement, idx) => {
        if (
          selectedBoxIds.includes(
            `page-${laElement.page}-element-${laElement.id}`,
          )
        ) {
          setIndex(idx);
          return;
        }
      });
    }
  }, [selectedBoxIds]);

  return (
    <>
      <div>
        {laElements.length > 0 && (
          <div className="body flex min-w-full flex-col items-center overflow-auto rounded-lg bg-background p-4">
            <table className="flex w-full border-collapse flex-col">
              <tbody className="flex w-full flex-col items-start justify-start rounded">
                {laElements.map((laElement, idx) => {
                  const linecontent = values[idx];
                  const isSelected =
                    curIndex === idx ||
                    (curIndex === -1 &&
                      selectedBoxIds.includes(
                        `page-${laElement.page}-element-${laElement.id}`,
                      ));
                  const isHovered =
                    hoverIndex === idx ||
                    (hoverIndex === -1 &&
                      hoveredBoxIds.includes(
                        `page-${laElement.page}-element-${laElement.id}`,
                      ));

                  if (!laElement) return null;

                  return (
                    <tr
                      className={cn({
                        "m-0.5 w-full break-words rounded text-left text-black text-opacity-90":
                          true,
                        "bg-accent-blue-background/50":
                          !disabled && (isHovered || isSelected),
                        "outline outline-1 outline-accent-blue": isSelected,
                      })}
                      id={`row-page-${laElement.page}-element-${laElement.id}`}
                      key={`idx:${idx}`}
                      onMouseEnter={() => {
                        setHoveredBoxIds([
                          `page-${laElement.page}-element-${laElement.id}`,
                        ]);
                        setHoverIndex(idx);
                      }}
                      onMouseLeave={() => {
                        setHoveredBoxIds([]);
                        setHoverIndex(-1);
                      }}
                      onClick={e => {
                        e.stopPropagation();
                        setIsRowClicked(true);
                        if (laElement.id < 0 || laElement.id > orgLargestId) {
                          setFocusEnable(false);
                        } else {
                          setFocusEnable(true);
                        }
                        if (curIndex !== -1 && (e.ctrlKey || e.metaKey)) {
                          if (additionalFocusIndexes.length === 0) {
                            (
                              document.activeElement as
                                | HTMLInputElement
                                | HTMLTextAreaElement
                            ).blur();
                          }
                        } else {
                          // 박스가 있을때만
                          if (laElement.bounding_box) {
                            setSelectedBoxIds([
                              `page-${laElement.page}-element-${laElement.id}`,
                            ]);
                          } else {
                            setSelectedBoxIds([]);
                          }
                          setIndex(idx);
                          setHoveredBoxIds([]);
                          setHoverIndex(-1);
                          setAdditionalFocusIndexes([]);
                        }
                      }}
                    >
                      <td
                        className={cn({
                          "flex w-full whitespace-normal p-2": true,
                          "shadow-inline":
                            idx === curIndex ||
                            additionalFocusIndexes.includes(idx),
                        })}
                        id={`td-${idx}`}
                      >
                        <code className="language-html !bg-transparent !text-sm">
                          {linecontent}
                        </code>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </>
  );
};

export default ParsingResultLAHtmlView;
